import { get } from '../../../shared/api';
import { PagedResponseDTO, PageSearchQueryConfig } from '../../../shared/constants';
import { generateSearchQuery } from '../../../shared/helpers';
import { LogsDTO } from './logs.dto';

export const getLogsRequest = (pageConfig: PageSearchQueryConfig = {}): Promise<PagedResponseDTO<LogsDTO[]>> => {
  const query = generateSearchQuery(pageConfig);
  return get<PagedResponseDTO<LogsDTO[]>>(`/log${query}`);
};
